__turbopack_context__.v({
  "wrapper": "index-module__DH0IAa__wrapper",
});
